module.exports = __webpack_public_path__ + "static/img/solve9.16ec127.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/solve9.svg
// module id = CSHf
// module chunks = 0